var styles = {"icon":"styles_icon__58Z3K"};

export default styles;
//# sourceMappingURL=styles.css.js.map
